/** The IMEIs as typed: one per line, or separated by commas, semicolons or spaces; duplicates folded. */
export const parseImeis = (text: string): string[] =>
  Array.from(new Set(text.split(/[\s,;]+/).map((s) => s.trim()).filter(Boolean)));
